<style lang="less" scoped>
.pri-ul {
    >li {
        padding: 5px 0;
        // padding-left: 30%;
    }
}
</style>

<template>
    <div>
        <h2 class="pageTitle">客戶管理</h2>

        <!-- 搜索Box -->
        <div class="sb searchBoxWrap">
            <div class="al">
                <Input type="text" v-model="keyword" clearable @on-clear="search" @on-keydown.enter="search" /> 
                <Button type="primary" class="searchBtn" @click="search">搜索</Button>
            </div>
            <div>
                <Button type="info" @click="showAdd=true">+ 創建新客戶</Button>
            </div>
        </div>

        <div class="tableWrap">
            <Table :columns="columns" :data="list" :searchable="false" border :loading="tableLoad" @on-row-click="showDetailFn">
                <template slot="action" slot-scope="{row}">
                    <div class="ju" @click.stop.prevent="">
                        <Button type="warning" size='small' style="margin-right: 10px;" @click="edit(row)">編輯</Button>
                        <Button type="error" size='small' @click="del(row)">刪除</Button>
                    </div>
                </template>
                <template slot="customer_type" slot-scope="{row}">
                    <span v-if="row.customer_type==1">月結</span>
                    <span v-if="row.customer_type==2">現結</span>
                </template>
            </Table>
        </div>

        <div class="PageWrap">
            <Page :current="page" :page-size="offset" :total="total" @on-change="changePage"></Page>
        </div>

        <!-- 創建 -->
        <Modal v-model="showAdd">
            <div slot="header" class="ModalHeader">
                <div>創建新客戶</div>
            </div>

            <div>
                <Form :model="addForm" :rules="rules" :label-width="130" ref="addForm">
                    <FormItem prop="name" label="客戶名稱">
                        <Input v-model="addForm.name" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="name_no" label="客戶編號">
                        <Input v-model="addForm.name_no" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="customer_type" label="客戶種類">
                        <Select v-model="addForm.customer_type" style="width:250px" @on-keydown.enter="okAdd" >
                            <Option value="1">月結</Option>
                            <Option value="2">現結</Option>
                        </Select>
                    </FormItem>
                    <FormItem prop="contact_person" label="聯繫人">
                        <Input v-model="addForm.contact_person" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="phone" label="電話">
                        <Input v-model="addForm.phone" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="email" label="E-Mail">
                        <Input v-model="addForm.email" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="fax" label="傳真號碼">
                        <Input v-model="addForm.fax" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="address" label="地址">
                        <Input v-model="addForm.address" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showAdd=false">取消</Button>
                <Button type="info" size="small" @click="okAdd" :loading="load">+ 創建</Button>
            </div>
        </Modal>

        <!-- 編輯 -->
        <Modal v-model="showEdit">
            <div slot="header" class="ModalHeader">
                <div>創建客戶</div>
            </div>

            <div>
                <Form :model="editForm" :rules="rules" :label-width="130" ref="editForm">
                    <FormItem prop="name" label="客戶名稱">
                        <Input v-model="editForm.name" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="name_no" label="客戶編號">
                        <Input v-model="editForm.name_no" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="customer_type" label="客戶種類">
                        <Select v-model="editForm.customer_type" style="width:250px" @on-keydown.enter="okAdd" >
                            <Option value="1">月結</Option>
                            <Option value="2">現結</Option>
                        </Select>
                    </FormItem>
                    <FormItem prop="contact_person" label="聯繫人">
                        <Input v-model="editForm.contact_person" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="phone" label="電話">
                        <Input v-model="editForm.phone" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="email" label="E-Mail">
                        <Input v-model="editForm.email" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="fax" label="傳真號碼">
                        <Input v-model="editForm.fax" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="address" label="地址">
                        <Input v-model="editForm.address" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showEdit=false">取消</Button>
                <Button type="info" size="small" @click="okEdit" :loading="load">編輯</Button>
            </div>
        </Modal>

        <Modal v-model="showDetail" title="客戶資料">
            <ul class="pri-ul">
                <li>客戶名稱: {{detail.name}}</li>
                <li>客戶編號: {{detail.name_no}}</li>
                <li>客戶種類: {{detail.customer_type==1 ? "月結客戶" : "現結客戶"}}</li>
                <li>創建時間: {{detail.createAt}}</li>
                <li>聯繫人: {{detail.contact_person}}</li>
                <li>電話: {{detail.phone}}</li>
                <li>E-Mail: {{detail.email}}</li>
                <li>傳真號碼: {{detail.fax}}</li>
                <li>地址: {{detail.address}}</li>
            </ul>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            columns: [
                { title: "編號", key: "id", sortable: true, align:"center", width: 100 },
                { title: "客戶名稱", key: "name", sortable: true, align:"center" },
                { title: "客戶種類", slot: "customer_type", sortable: true, align:"center" },
                { title: "創建時間", key: "createAt", sortable: true, align:"center" },
                { title: "聯繫人", key: "contact_person", sortable: true, align:"center" },
                { title: "電話", key: "phone", sortable: true, align:"center" },
                { title: "操作", slot: "action", align:"center" },
            ],
            list: [],
            keyword: "",
            page: 1,
            total: 0,
            showAdd: false,
            showEdit: false,
            showDetail: false,
            detail: {},
            addForm: {
                name: "",
                name_no: "",
                customer_type: "1",
                contact_person: "",
                phone: "",
                email: "",
                fax: "",
                address: "",
            },
            editForm: {
                name: "",
                name_no: "",
                customer_type: "1",
                contact_person: "",
                phone: "",
                email: "",
                fax: "",
                address: "",
            },
            rules: {
                name: [ { required: "true", message: "請輸入客戶名稱", trigger: "blur" } ],
                name_no: [ { required: "true", message: "請輸入客戶編號", trigger: "blur" } ],
                customer_type: [ { required: "true", message: "請選擇客戶種類" } ],
                // contact_person: [ { required: "true", message: "請輸入聯繫人", trigger: "blur" } ],
                // phone: [ { required: "true", message: "請輸入電話號碼", trigger: "blur" } ],
                // email: [ { required: "true", message: "請輸入E-Mail", trigger: "blur" } ],
                // fax: [ { required: "true", message: "請輸入傳真號碼", trigger: "blur" } ],
                // address: [ { required: "true", message: "請輸入地址", trigger: "blur" } ],
            },
            load: false,
            keyword: "",
            tableLoad: false,
        }
    },
    watch: {
        showAdd () { this.load = false },
        showEdit () { this.load = false },
    },
    computed: {
        role () { return this.$store.state.role },
        offset () { return this.$store.state.offset },
    },
    created () {
        if (this.role == 2) {
            this.columns.pop()
        }
        this.showTable()
    },
    methods:{
        showDetailFn (e) {
            this.showDetail = true
            this.detail = e
        },
        search () {
            this.page = 1
            this.showTable()
        },
        showTable () {
            this.tableLoad = true
            this.$axios({
                url: "admin/customer/",
                params: {
                    page: this.page,
                    offset: this.offset,
                    search: this.keyword
                }
            }).then(res => {
                console.log(res)
                this.tableLoad = false
                if (res.data.data) {
                    this.list = res.data.data
                    this.total = res.data.count
                    if (res.data.data.length == 0 && this.page > 1) {
                        this.page--
                        this.showTable()
                    }
                } else {
                    this.list = []
                    this.total = 0
                }
            }).catch(e => {
                console.log(e)
                this.tableLoad = false
                this.$Message.error("網絡錯誤, 請稍後再試")
            })
        },
        changePage (e) {
            this.page = e
            this.showTable()
        },
        okAdd () {
            let that =this
            this.$refs.addForm.validate(flag => {
                if (flag) {
                    that.load = true
                    that.$axios({
                        url: "admin/customer/",
                        method:"POST",
                        data: {
                            name: that.addForm.name,
                            name_no: that.addForm.name_no,
                            customer_type: that.addForm.customer_type * 1,
                            contact_person: that.addForm.contact_person,
                            phone: that.addForm.phone,
                            email: that.addForm.email,
                            fax: that.addForm.fax,
                            address: that.addForm.address
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("創建成功")
                            that.showTable()
                            that.showAdd = false
                            that.$refs.addForm.resetFields()
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        okEdit () {
            let that =this
            this.$refs.editForm.validate(flag => {
                if (flag) {
                    console.log(flag)
                    that.load = true
                    that.$axios({
                        url: "admin/customer/",
                        method:"PUT",
                        data: {
                            id: that.editForm.id,
                            name: that.editForm.name,
                            name_no: that.editForm.name_no,
                            customer_type: that.editForm.customer_type * 1,
                            contact_person: that.editForm.contact_person,
                            phone: that.editForm.phone,
                            email: that.editForm.email,
                            fax: that.editForm.fax,
                            address: that.editForm.address
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("編輯成功")
                            that.showTable()
                            that.showEdit = false
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        edit (item) {
            this.showEdit = true
            this.editForm.id = item.id
            this.editForm.name = item.name
            this.editForm.name_no = item.name_no
            this.editForm.customer_type = item.customer_type + ""
            this.editForm.contact_person = item.contact_person
            this.editForm.phone = item.phone
            this.editForm.email = item.email
            this.editForm.fax = item.fax
            this.editForm.address = item.address
        },
        del (item) {
            let that = this
            that.$Modal.confirm({
                title: '提示',
                content : "確定刪除這條信息?",
                onOk () {
                    that.$axios({
                        url: "admin/customer/",
                        method:"DELETE",
                        data: {
                            id: item.id
                        }
                    }).then(res => {
                        that.$Message.success('已刪除')
                        that.showTable()
                    })
                }
            })
        }
    }
}
</script>

